import { render, staticRenderFns } from "./Hospitalisations.vue?vue&type=template&id=2e6867be&scoped=true"
import script from "./Hospitalisations.vue?vue&type=script&lang=js"
export * from "./Hospitalisations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6867be",
  null
  
)

export default component.exports